/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBoxGrid = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path
          clipRule="evenodd"
          d="M11.47 2.152a1 1 0 0 1 1.06 0l8 5A1 1 0 0 1 21 8v4h-2V9.804l-6 3.75V21a1 1 0 0 1-1.53.848l-8-5A1 1 0 0 1 3 16V8a1 1 0 0 1 .47-.848zm.53 9.669L18.113 8 12 4.18 5.887 8zM5 9.804v5.642l6 3.75v-5.642z"
          fillRule="evenodd"
        />
        <path d="M14 14h3v3h-3zm0 4h3v3h-3zm4-4h3v3h-3zm0 4h3v3h-3z" />
      </g>
    </g>
  </Icon>
);
export { SvgBoxGrid as BoxGrid };
